module.exports = __webpack_public_path__ + "static/media/leggings.50c1aefc.jpg";